<template>
  <div>
    <audio id="modalAudio" ref="modalAudio" controls="true">
      <source :src="model.url" />
    </audio>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: null, default: '' }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(model) {
        this.$emit('input', model)
      }
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.model = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/media/audio-preview.vue